import React from "react";

import classNames from "classnames";
import brand from "@utils/brand";
import { HeadingWIcon, PersonModal } from "@molecules";
import { Text, Image } from "@atoms";

const StaffSection = ({ heading, copy, people, compact, small }) => {
  const { romero } = brand;
  return (
    <div className="py-12 sm:py-24">
      <HeadingWIcon
        heading={heading}
        copy={copy}
        small={!romero}
        colors={romero ? { heading: "text-blue", text: "text-gray-light" } : ""}
      />
      <ul
        className={classNames(
          "mt-6 grid grid-cols-2 gap-6 sm:mt-12 sm:grid-cols-3 lg:gap-12",
          {
            "md:grid-cols-4": small,
          }
        )}
      >
        {!compact &&
          people &&
          people.length &&
          people.map(p => (
            <li key={p.uid}>
              <PersonModal {...p} />
            </li>
          ))}
        {compact &&
          people &&
          people.length &&
          people.map(p => (
            <li key={p.uid} className="flex w-full flex-col gap-4">
              {p.image && (
                <Image
                  image={p.image}
                  ixParams={{ crop: "faces" }}
                  aspectRatio={[1, 1]}
                  fitHeight
                />
              )}
              <Text variant="h4" className="font-serif">
                {p.name}
              </Text>
            </li>
          ))}
      </ul>
    </div>
  );
};

StaffSection.defaultProps = {};

export default StaffSection;
